// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header___s_q36","breadcrumb":"styles__breadcrumb___8Gdwf","arrow_right":"styles__arrow_right___xcMgx","current_page":"styles__current_page___3nmA4","confirm_page":"styles__confirm_page___1ZsWR","breadcrumb_align":"styles__breadcrumb_align___3e82k","breadcrumb_center":"styles__breadcrumb_center___3XKdE"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Breadcrumb/styles.css
// module id = 3149
// module chunks = 0